import { render, staticRenderFns } from "./AuthorAvatarImg.vue?vue&type=template&id=3c86f5ea&scoped=true&"
import script from "./AuthorAvatarImg.vue?vue&type=script&lang=js&"
export * from "./AuthorAvatarImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c86f5ea",
  null
  
)

export default component.exports